var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUserAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 18.375a7.09 7.09 0 007.087-7.088A7.09 7.09 0 0016.8 4.2a7.09 7.09 0 00-7.087 7.087 7.09 7.09 0 007.087 7.088zm6.3 1.575h-2.712a8.576 8.576 0 01-7.176 0H10.5a6.3 6.3 0 00-6.3 6.3v.787A2.363 2.363 0 006.563 29.4h20.475a2.363 2.363 0 002.362-2.363v-.787a6.3 6.3 0 00-6.3-6.3z",
    fill: "#00A6CE"
  })));
}

export default SvgUserAlt;